var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150.5 158.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#251b58;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 150.49,
    height: 158.77
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    className: "cls-3",
    d: "M143,79.88c-.62-11.33-3.19-22.47-8.78-32.54A68.45,68.45,0,0,0,97.81,16.23a67.7,67.7,0,0,0-82.62,33.7C5.24,70,5.07,95.4,13,116.16a68.23,68.23,0,0,0,6.62,13,66.25,66.25,0,0,0,33.45,25.94A68.67,68.67,0,0,0,113,147.35,68.76,68.76,0,0,0,142.48,98a117.5,117.5,0,0,0,.5-18.09m-7.61,8.29h0c-.64,33.69-27.29,60.8-60.1,60.8s-59.46-27.11-60.1-60.8h0c0-.21,0-.42,0-.64s0-.4,0-.6h0c.6-35.79,27.27-64.61,60.1-64.61s59.49,28.82,60.1,64.61h0c0,.2,0,.4,0,.6s0,.43,0,.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    className: "cls-3",
    d: "M.72,73.26A76.18,76.18,0,0,1,33.4,18.52,76.08,76.08,0,0,1,99.82,9.9,73.42,73.42,0,0,1,136.9,38.65a75.4,75.4,0,0,1,7.33,14.44,97,97,0,0,1,6.22,31.59,97.47,97.47,0,0,0-6.22-37.45,75.4,75.4,0,0,0-7.33-14.44A73.5,73.5,0,0,0,99.82,4,76.12,76.12,0,0,0,33.4,12.66,76.18,76.18,0,0,0,.72,67.4,130.39,130.39,0,0,0,0,84.05q.12-5.42.68-10.79"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnIcon);
export default __webpack_public_path__ + "static/media/OwnIcon.802d170c8e680b4476256ad0e4e3a41b.svg";
export { ForwardRef as ReactComponent };